import validate from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/node_modules/.pnpm/nuxt@3.16.2_eslint@9.25.1_rollup@4.40.0_sass@1.87.0_stylelint@16.18.0_typescript@5.8.3_vite@6.3.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/middleware/auth.global.ts";
import track_45global from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/middleware/track.global.ts";
import manifest_45route_45rule from "/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/node_modules/.pnpm/nuxt@3.16.2_eslint@9.25.1_rollup@4.40.0_sass@1.87.0_stylelint@16.18.0_typescript@5.8.3_vite@6.3.2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  track_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  report: () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/middleware/report.ts"),
  "scroll-top": () => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/middleware/scrollTop.ts")
}